import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import FullPageSpinner from 'apex-web/lib/components/common/FullPageSpinner/FullPageSpinner';
import path from '../helpers/path';
import { useEffect } from 'react';
import VerifyEmailContainer from 'apex-web/lib/components/VerifyEmail/VerifyEmailContainer';
import ResetPasswordFormContainer from 'apex-web/lib/components/ResetPasswordForm/ResetPasswordFormContainer';
import ConfirmWithdrawContainer from 'apex-web/lib/components/ConfirmWithdraw/ConfirmWithdrawContainer';
import DepositConfirmationModalContainer from 'apex-web/lib/components/DepositConfirmation/DepositConfirmationModalContainer';
import VerifyAddressContainer from 'apex-web/lib/components/VerifyAddress/VerifyAddressContainer';
import VerifyDeviceContainer from 'apex-web/lib/components/VerifyDevice/VerifyDeviceContainer';
import {
  checkForVerifyEmailParam,
  checkForResetPassParam,
  checkForConfirmWithdrawParam,
  checkForDepositConfirmationParam,
  checkForLoginParam,
  checkForVerifyDeviceParam
} from 'apex-web/lib/helpers/emailLinksHelper';
import { checkForVerifyAddressParam } from 'apex-web/lib/helpers/homePageLayoutHelper';

const RedirectWithLoaderPage = ({
  pendingAuth,
  isAuthenticated,
  isAuthenticating
}) => {
  if (pendingAuth || (!isAuthenticated && isAuthenticating)) {
    return (
      <div>
        <FullPageSpinner pastDelay isVisible />
      </div>
    );
  }

  if (checkForVerifyEmailParam()) {
    return <VerifyEmailContainer />;
  } else if (checkForConfirmWithdrawParam())
    return <ConfirmWithdrawContainer />;
  else if (checkForResetPassParam()) return <ResetPasswordFormContainer />;
  else if (checkForDepositConfirmationParam())
    return <DepositConfirmationModalContainer />;
  else if (checkForLoginParam()) return <Redirect to={path('/login')} />;
  else if (checkForVerifyAddressParam()) return <VerifyAddressContainer />;
  else if (checkForVerifyDeviceParam()) return <VerifyDeviceContainer />;
  else {
    if (!isAuthenticated) {
      return <Redirect to={path('/login')} />;
    } else {
      return <Redirect to={path('/dashboard')} />;
    }
  }
};

const mapStateToProps = state => ({
  isAuthenticating: !!localStorage.getItem('token'),
  isAuthenticated: state.auth.isAuthenticated,
  pendingAuth: state.auth.pending
});

export default connect(mapStateToProps)(RedirectWithLoaderPage);
